<p-sidebar [(visible)]="showaddUpdateModal" [position]="'right'" (onHide)="closePaymentDialogue()"
    [closeOnEscape]="false" [dismissible]="false" [style]="{width:'60rem'}">
    <ng-template pTemplate="header">
        <h3>{{context}} Receipt Refund</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <app-receipt-refund-add #payment [currentReceipt]="currentSelectedRecord"
            (changeModalStatus)="changeAddUpdateModelState($event)"></app-receipt-refund-add>
    </ng-template>
</p-sidebar>

<app-receipt-refund-list [paymentListData]="recordList"
    (changeModelStatus)="changeAddUpdateModelState($event)"></app-receipt-refund-list>